export const openAccountSteps = [
    { name: 'STATEMENT' },
    {
        name: 'IDCARD', // 跳转时候 router 中对应的 name
        step: '1.1', // 后台Step mapping
        applyStatus: '1000', // 对应applyStatus
    },
    {
        name: 'BANKCARD',
        step: '1.2',
        applyStatus: '1010',
    },
    {
        name: 'EMPLOYMENT',
        step: '1.3',
        applyStatus: '1020',
    },
    {
        name: 'FINANCE',
        step: '1.4',
        applyStatus: '1030',
    },
    {
        name: 'INVESTMENT',
        step: '1.5',
        applyStatus: '1040',
    },
    {
        name: 'ACCOUNT',
        step: '1.6',
        applyStatus: '1050',
    },
    {
        name: 'TRADECLASSES',
        step: '1.6',
        applyStatus: '1050',
    },
    {
        name: 'IDENTITYEXPOSURE',
        step: '1.7',
        applyStatus: '1060',
    },
    {
        name: 'TAXW8',
        step: '1.8',
        applyStatus: '1070',
    },
    {
        name: 'DISCLOSURE',
        step: '1.9',
        applyStatus: '1080',
    },
    {
        name: 'SIGNATURE',
        step: '1.10',
        applyStatus: '1090',
    },
    {
        name: 'FACEID',
        step: '1.11',
        applyStatus: '1100',
    },
    {
        name: 'APPLYCA',
        step: '1.12',
        applyStatus: '1110',
    },
]

export const hkOpenAccountSteps = [
    {
        name: 'HK_IDCARD',
        step: '1.1', // 后台Step mapping
        applyStatus: '1000', // 对应applyStatus
    },
    {
        name: 'USERINFO',
        step: '1.2',
        applyStatus: '1010',
    },
    {
        name: 'PROOFADDRESS',
        step: '1.3',
        applyStatus: '1011',
    },
    // 下面是复用内地的功能
    {
        name: 'EMPLOYMENT',
        step: '1.4',
        applyStatus: '1020',
    },
    {
        name: 'FINANCE',
        step: '1.5',
        applyStatus: '1030',
    },
    {
        name: 'INVESTMENT',
        step: '1.6',
        applyStatus: '1040',
    },
    // ACCOUNT、TRADECLASSES当做同一步骤的两个页面
    {
        name: 'ACCOUNT',
        step: '1.6',
        applyStatus: '1050',
    },
    {
        name: 'TRADECLASSES',
        step: '1.6',
        applyStatus: '1050',
    },
    {
        name: 'IDENTITYEXPOSURE',
        step: '1.7',
        applyStatus: '1060',
    },
    {
        name: 'TAXW8',
        step: '1.8',
        applyStatus: '1070',
    },
    {
        name: 'DISCLOSURE',
        step: '1.9',
        applyStatus: '1080',
    },
    {
        name: 'SIGNATURE',
        step: '1.10',
        applyStatus: '1090',
    },
]

export const getStepList = type => {
    if (type == 'hk') {
        return hkOpenAccountSteps
    }
    return openAccountSteps
}

/** 被驳回状态的步骤映射关系 */
// [1, '身份证/证件照片有问题', 'IDCARD'],
// [2, '个人资料有问题', 'USERINFO'],
// [3, '银行账户资料有问题', 'BANKCARD'],
// [4, '邮箱资料有问题', 'EMAIL'],
// [5, '学历及工作情况有问题', 'EMPLOYMENT'],
// [6, '财务资料有问题', 'FINANCE'],
// [7, '投资目的及经验有问题', 'INVESTMENT'],
// [8, '衍生产品认识有问题', 'DERIVATIVES'],
// [9, '身份披露有问题', 'IDENTITYEXPOSURE'],
// [10, '税务信息及W8报表有问题', 'TAXW8'],
// [11, '客户签字有问题', 'SIGNATURE'],
// // 香港开户特有
// [12, '地址证明照片有问题', 'ADDRESS'],

export const rejectStep = [
    {
        key: 'FILE',
        pathName: 'STATEMENT',
        hk_pathName: 'HK_IDCARD', // 香港开户对应的 NAME
        msg: '开户身份证明文件有问题',
    },
    {
        key: 'STATEMENT',
        pathName: 'STATEMENT',
        msg: '香港市场账户信息有误',
    },
    {
        key: 'IDCARD', // 后端返回的名称
        pathName: 'IDCARD', // 内地对应的跳转 NAME
        hk_pathName: 'HK_IDCARD', // 香港开户对应的 NAME
        msg: '身份证/证件照片有问题',
    },
    {
        key: 'USERINFO',
        pathName: 'IDCARD',
        hk_pathName: 'USERINFO',
        msg: '个人资料有问题',
    },
    {
        key: 'BANKCARD',
        pathName: 'BANKCARD',
        hk_pathName: '',
        msg: '银行账户资料有问题',
    },
    {
        key: 'EMAIL',
        pathName: 'BANKCARD',
        hk_pathName: 'USERINFO',
        msg: '邮箱资料有问题',
    },
    {
        key: 'ADDRESS',
        pathName: '',
        hk_pathName: 'PROOFADDRESS',
        msg: '地址证明照片有问题',
    },
    {
        key: 'EMPLOYMENT',
        pathName: 'EMPLOYMENT',
        hk_pathName: 'EMPLOYMENT',
        msg: '学历及工作情况有问题',
    },
    {
        key: 'FINANCE',
        pathName: 'FINANCE',
        hk_pathName: 'FINANCE',
        msg: '财务资料有问题',
    },
    {
        key: 'INVESTMENT',
        pathName: 'INVESTMENT',
        hk_pathName: 'INVESTMENT',
        msg: '投资目的及经验有问题',
    },
    {
        key: 'DERIVATIVES',
        pathName: 'INVESTMENT', // 投资经验页面
        hk_pathName: 'INVESTMENT',
        msg: '衍生产品认识有问题',
    },
    {
        key: 'IDENTITYEXPOSURE',
        pathName: 'IDENTITYEXPOSURE',
        hk_pathName: 'IDENTITYEXPOSURE',
        msg: '身份披露有问题',
    },
    {
        key: 'TAXW8',
        pathName: 'TAXW8',
        hk_pathName: 'TAXW8',
        msg: '税务信息及W8报表有问题',
    },
    {
        key: 'SIGNATURE',
        pathName: 'SIGNATURE',
        hk_pathName: 'SIGNATURE',
        msg: '客户签字有问题',
    },
    {
        key: 'FACEID',
        pathName: 'FACEID',
        hk_pathName: '',
        msg: 'CA认证不通过',
    },
]

// 开户审核状态
// 预开户中
export const preOpenStatusCode = 1500
export const rejectTodoStatusCode = 1900 // 审核被驳回，待补充资料
export const approvingStatusCode = 2000 // 资料提交完成等待审核
export const failedStatusCode = 3010 // 开通账户失败
export const successStatusCode = 4000 // 开通账户成功
export const rejectStatusCode = 5000 // 审核不通过，直接被拒绝  // 需要展示成审核中
export const deletedStatusCode = 6000 // 已删除
export const foreignIDAuditStatusCode = 1600 // 待录入海外证件
export const rependingAmlStatusCode = 1901 // 一审被驳回
export const repending2StatusCode = 1902 // 二审被驳回
export const rependingROStatusCode = 1903 // RO审被驳回
export const rependingCertStatusCode = 1904 // 认证审被驳回

export const EditInformation = [
    rejectTodoStatusCode,
    rependingAmlStatusCode,
    repending2StatusCode,
    rependingROStatusCode,
    rependingCertStatusCode,
    foreignIDAuditStatusCode,
] // 需要展示编辑资料的状态

// export const AccountOpeningFailed = [3010].concat(EditInformation)                  // 展示开户状态失败

// OAStatusPending       OAStatus = 1000 // 开户申请中
// OAStatusForeignIDAudit  OAStatus = 1600 // 待录入海外证件
// OAStatusRepending1    OAStatus = 1900 // 一审被驳回
// OAStatusRependingAml  OAStatus = 1901 // 反洗钱审被驳回
// OAStatusRepending2    OAStatus = 1902 // 二审被驳回
// OAStatusRependingRO   OAStatus = 1903 // RO审被驳回
// OAStatusRependingCert OAStatus = 1904 // 认证审被驳回
// OAStatusSubmit        OAStatus = 2000 // 资料提交完成等待审核
// OAStatusSubmitB       OAStatus = 2001 // 一审待定
// OAStatusAudited1      OAStatus = 2010 // 一审通过待反洗钱审核
// OAStatusAudited1B     OAStatus = 2011 // 反洗钱审待定
// OAStatusAuditedAml    OAStatus = 2020 // 反洗钱审核通过待二审
// OAStatusAuditedAmlB   OAStatus = 2021 // 二审待定
// OAStatusAudited2      OAStatus = 2030 // 二审通过待RO审
// OAStatusAudited2B     OAStatus = 2031 // RO审待定
// OAStatusAuditedRO     OAStatus = 2040 // RO审通过
// OAStatusAuditedROB    OAStatus = 2041 // 认证审核待定
// OAStatusAuditedCert   OAStatus = 2050 // 认证审核通过待
// OAStatusApprove       OAStatus = 3000 // 所有审核通过待开通账户
// OAStatusOpenAcctFail  OAStatus = 3010 // 开通账户失败
// OAStatusSuccess       OAStatus = 4000 // 开通账户成功
// OAStatusReject        OAStatus = 5000 // 审核被拒绝
// OAStatusDelete        OAStatus = 6000 // 被删除

// CAStatusPending       CAStatus = 1000 // 等待验证
// CAStatusLivingBodyOk  CAStatus = 2000 // 公安活体成功
// CAStatusLivingBodyErr CAStatus = 2001 // 公安活体失败
// CAStatusBankOk        CAStatus = 3000 // 银行认证成功
// CAStatusBankErr       CAStatus = 3001 // 银行认证失败
// CAStatusSubDnOk       CAStatus = 4000 // 证书主题成功
// CAStatusSubDnErr      CAStatus = 4001 // 证书主题失败
// CAStatusCertSnOk      CAStatus = 5000 // 获取证书成功
// CAStatusCertSnErr     CAStatus = 5001 // 获取证书失败
// CAStatusPushPDFOk     CAStatus = 6000 // 推送PDF成功
// CAStatusPushPDFErr    CAStatus = 6001 // 推送PDF失败
// CAStatusMergePDFOk    CAStatus = 7000 // 签署PDF成功
// CAStatusMergePDFErr   CAStatus = 7001 // 签署PDF失败

// CashInStatusPending     CashInStatus = 1000 // 待提交
// CashInStatusSubmit      CashInStatus = 1001 // 入金已提交待审核
// CashInStatusBack        CashInStatus = 1900 // 入金审核驳回
// CashInStatusPass        CashInStatus = 2000 // 入金审核通过
// CashInStatusCertSubmit  CashInStatus = 2010 // 已提交待审核
// CashInStatusCertBack    CashInStatus = 2020 // 认证审核驳回
// CashInStatusCertPending CashInStatus = 2030 // 认证审核待定

// StockStatusPending = 1000 // 待提交
// StockStatusSubmit  = 1001  // 转仓已提交待审核
// StockStatusBack    = 1900    // 转仓审核驳回
//StockStatusPass    = 2000    // 转仓审核通过
